import {
    AberturaEmMassaAudienciaService,
    AtenderAtendimentoService,
    AtualizarAtendimentoService,
    CancelarCasoService,
    ExecutarAcaoAtendimentoService,
    InserirCasoDinamicamenteService,
    ReabrirCasoService,
    ValidaCasoRecorrenciaService,
    ValidarUsuarioEditarDescricaoService,
} from "../../../Services/Geral/Atendimentos/AtendimentosService";
import { ICasoDinamico } from "../../../Interfaces/Geral/Atendimentos/AtendimentosInterface";
import { Controller } from "../../Controller";
import {
    IAtualizarAtendimento,
    ICancelarCaso,
    IReabrirCaso,
} from "../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";

export async function InserirCasoDinamicamenteController(
    requestBody: ICasoDinamico,
    uniqueID?: string
) {
    return Controller(
        InserirCasoDinamicamenteService(requestBody, uniqueID),
        "Seu caso foi inserido com sucesso"
    );
}

export async function ValidaCasoRecorrenciaController(
    requestBody: ICasoDinamico
) {
    return Controller(ValidaCasoRecorrenciaService(requestBody));
}

export async function AberturaEmMassaAudienciaController(
    requestBody: ICasoDinamico,
    ID_AUDIENCIA?: number
) {
    return Controller(
        AberturaEmMassaAudienciaService(requestBody, ID_AUDIENCIA)
    );
}

export async function ExecutarAcaoAtendimentoController(
    ID_CASO: number,
    ID_ACAO_ETAPA_CASO: number,
    DS_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO?: string
) {
    return Controller(
        ExecutarAcaoAtendimentoService(
            ID_CASO,
            ID_ACAO_ETAPA_CASO,
            DS_ACAO_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
        ),
        "Ação executada com sucesso!"
    );
}

export async function AtualizarAtendimentoController(
    ID_CASO: number,
    requestBody: IAtualizarAtendimento
) {
    return Controller(AtualizarAtendimentoService(ID_CASO, requestBody));
}

export async function ValidarUsuarioEditarDescricaoController(ID_CASO: number) {
    return Controller(ValidarUsuarioEditarDescricaoService(ID_CASO));
}

export const AtenderAtendimentoController = (ID_CASO: number) =>
    Controller(
        AtenderAtendimentoService(ID_CASO),
        "Agora você é o responsãvel por esse caso!"
    );

export async function CancelarCasoController(requestBody: ICancelarCaso) {
    return Controller(CancelarCasoService(requestBody));
}

export async function ReabrirCasoController(requestBody: IReabrirCaso) {
    return Controller(ReabrirCasoService(requestBody));
}
